import { Toasts, Toast } from '@cb/apricot-react';
import { useCallback, useState } from 'react';

const useToasts = () => {
  const [errorMessage, setErrorMessage] = useState<Nullable<string>>(null);
  const [successMessage, setSuccessMessage] = useState<Nullable<string>>(null);

  const handleDismissErrorValidation = useCallback(() => {
    setErrorMessage(null);
  }, []);

  const handleDismissSuccessValidation = useCallback(() => {
    setSuccessMessage(null);
  }, []);

  const render = () => {
    return (
      // @ts-ignore
      <Toasts offsetTop={24}>
        <Toast
          controlled
          message={errorMessage ?? ''}
          onClick={handleDismissErrorValidation}
          onDismiss={handleDismissErrorValidation}
          show={!!errorMessage}
          type="warning"
        />
        <Toast
          controlled
          message={successMessage ?? ''}
          onClick={handleDismissSuccessValidation}
          onDismiss={handleDismissSuccessValidation}
          show={!!successMessage}
          type="success"
        />
      </Toasts>
    );
  };

  return {
    errorMessage,
    render,
    toastErrorMessage: setErrorMessage,
    toastSuccessMessage: setSuccessMessage,
  };
};

export default useToasts;
